import {defineStore} from 'pinia'
import DataSource from "devextreme/data/data_source";
import { ref} from "vue";
import {useKeluargaListModel} from "@/stores/models/keluarga-list-model";

export const useKeluargaListStore = defineStore(
    'keluargaListStore',
    () => {
       
        const isLoading = ref(false);
       

        const dataSourceKeluargaList = ref(
            new DataSource({
                requireTotalCount: true,
                store: useKeluargaListModel().keluargaListCustomStore,
                filter: null,
            })
        );

        
        const state = ref(true);
        const onMuatButtonClick =()=>{
            state.value = false;
            dataSourceKeluargaList.value.reload();
        };

        const initialized = ()=>{     
            dataSourceKeluargaList.value.reload();
        };

        return {
            dataSourceKeluargaList,
            isLoading,
            onMuatButtonClick,
            initialized,
            state

        }
    }
);